module.exports = __webpack_public_path__ + "img/Symbol_RGB.4db35023.png";